<script setup lang="ts">
interface Props {
  visible: boolean
  text: string
  x: number
  y: number
}
defineProps<Props>()
</script>

<template>
  <div
    v-if="visible"
    class="floating-tooltip"
    :style="`position: fixed; left: ${x}px; top: ${y}px; transform: translate(-50%, +80%); z-index: 999;`"
  >
    {{ text }}
  </div>
</template>

<style scoped>
.floating-tooltip {
  font-family: "Utsukushi", sans-serif;
  font-size: max(12.22px, calc(1.72 * var(--u)));
  color: #fff;
  background-color: #800000c0;
  padding: max(2.22px, calc(0.313 * var(--u)));
  padding-bottom: max(3.33px, calc(0.469 * var(--u)));
  border-radius: 0.5vh;
  pointer-events: none;
}
</style>
